import React, { useEffect, useState } from "react";
import { corefetch, ImageURL } from "../../../Util/axios_core_helper";

export const CVideoSection = ({ id }) => {
  const [videoPath, setVideoPath] = useState("");
  const fetchVideoData = async () => {
    try {
      const response = await corefetch(`Videos/GetVideosFetchDetails?id=${id}`);
      if (response && response.length > 0) {
        setVideoPath(response[0].videopath);
      } else {
        setVideoPath("");
        console.error("No video data found");
      }
    } catch (error) {
      setVideoPath("");
    }
  };
  useEffect(() => {
    fetchVideoData();
  }, []);

  if (!videoPath || videoPath == "") {
    return null;
  }

  return (
    <>
      <section
        className="video-wrapper video section-padding bg-img bg-fixed"
        data-overlay-dark={5}
      >
        <div className="container">
          <div className="row">
            <div className="text-center col-md-12">
              <video
                id="autoplayVideo"
                autoPlay
                muted
                loop
                style={{ width: "100%" }}
              >
                <source src={`${ImageURL}${videoPath}`} type="video/mp4" />
              </video>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};
